/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/16/22
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {persistState} from "../helpers";

export type FavoritesState = number[];

const STORAGE_KEY = 'vega.state.favorites';
const storedState = localStorage.getItem(STORAGE_KEY);
const initialState: FavoritesState = storedState ? JSON.parse(storedState) : [];

export const slice = createSlice({
	name: 'favorites',
	initialState,
	reducers: {
		add: (state, action: PayloadAction<number> ) => {
			const newState = [ action.payload, ...state ];
			persistState(STORAGE_KEY, newState);
			return newState;
		},
		remove: (state, action: PayloadAction<number> ) => {
			const newState = state.filter(s => s !== action.payload);
			persistState(STORAGE_KEY, newState);
			return newState;
		},
	},
});

export const {add, remove} = slice.actions;
export default slice.reducer;